<template>
    <div class="bg-white dark:bg-slate-800 rounded-lg p-6 mb-4 border border-gray-200 dark:border-gray-700">
        <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-200">Status dos Reviews</h3>
            <button @click="fetchStats" 
                    class="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-md text-sm hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300">
                Atualizar
            </button>
        </div>
        
        <!-- Estatísticas do Dia -->
        <div class="grid grid-cols-3 gap-4 mb-4">
            <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-3 text-center">
                <div class="text-2xl font-bold text-gray-800 dark:text-gray-200">{{ stats.today.processed }}</div>
                <div class="text-xs text-gray-600 dark:text-gray-400">Processados Hoje</div>
                <div class="text-xs mt-1">
                    <span class="text-emerald-600 dark:text-emerald-400">{{ stats.today.approved }} aprovados</span>
                    <span class="mx-1 text-gray-400">|</span>
                    <span class="text-red-600 dark:text-red-400">{{ stats.today.rejected }} rejeitados</span>
                </div>
            </div>
            
            <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-3 text-center">
                <div class="text-2xl font-bold text-gray-800 dark:text-gray-200">{{ urgentCount }}</div>
                <div class="text-xs text-gray-600 dark:text-gray-400">Pendentes Urgentes</div>
                <div class="text-xs mt-1" :class="getUrgentStatusColor()">
                    {{ getUrgentStatus() }}
                </div>
            </div>
            
            <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-3 text-center">
                <div class="text-2xl font-bold text-gray-800 dark:text-gray-200">{{ remainingTimeFormatted }}</div>
                <div class="text-xs text-gray-600 dark:text-gray-400">Tempo Restante</div>
                <div class="text-xs mt-1" :class="getTimeRemainingColor()">
                    {{ getTimeRemainingStatus() }}
                </div>
            </div>
        </div>
        
        <!-- Progresso da Meta -->
        <div class="mb-4">
            <div class="flex justify-between text-sm mb-2 text-gray-700 dark:text-gray-300">
                <span>Meta: Zerar pendências até 12h</span>
                <span class="font-medium">{{ urgentCount }} restantes</span>
            </div>
            <div class="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-3">
                <div class="h-3 rounded-full transition-all duration-300" 
                     :class="getProgressBarColor()"
                     :style="{ width: getProgressPercentage() + '%' }"></div>
            </div>
            <div class="text-xs mt-2 text-gray-600 dark:text-gray-400">
                {{ getProgressMessage() }}
            </div>
        </div>
        
        <!-- Dica Útil -->
        <div v-if="currentTip" class="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3 border-l-4 border-blue-400">
            <div class="flex items-start space-x-2">
                <div class="flex-shrink-0 mt-0.5">
                    <div class="w-2 h-2 bg-blue-400 rounded-full"></div>
                </div>
                <div>
                    <div class="font-medium text-sm text-blue-800 dark:text-blue-300">Dica</div>
                    <div class="text-xs text-blue-700 dark:text-blue-400 mt-1">{{ currentTip }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OperatorStats',
    props: {
        urgentCount: {
            type: Number,
            default: 0
        },
        remainingTimeFormatted: {
            type: String,
            default: '00:00:00'
        },
        midDayPassed: {
            type: Boolean,
            default: false
        }
    },
    
    data() {
        return {
            stats: {
                today: {
                    processed: 0,
                    approved: 0,
                    rejected: 0,
                    avgTime: '0s'
                },
                dailyGoal: 50,
                weeklyStats: []
            },
            tips: [
                "Foque primeiro nos saques marcados como urgentes (até 12h)",
                "Valores acima de R$ 1.000 merecem atenção especial",
                "Usuários com score abaixo de 50 são mais arriscados",
                "Saques solicitados na madrugada podem ser suspeitos",
                "Use os botões de ação rápida para ganhar tempo",
                "Verifique o histórico de aprovações do usuário",
                "Tags de perigo indicam riscos elevados",
                "Primeiro saque do usuário sempre merece atenção"
            ],
            currentTip: '',
            tipInterval: null
        };
    },
    
    mounted() {
        this.fetchStats();
        this.rotateTips();
        this.tipInterval = setInterval(this.rotateTips, 30000); // Troca dica a cada 30s
    },
    
    beforeDestroy() {
        if (this.tipInterval) {
            clearInterval(this.tipInterval);
        }
    },
    
    methods: {
        async fetchStats() {
            try {
                const { data } = await axios.get('/api/cashout/review/operator-stats');
                this.stats = { ...this.stats, ...data };
            } catch (error) {
                console.error('Erro ao buscar estatísticas:', error);
                // Mock data para desenvolvimento
                this.stats.today = {
                    processed: Math.floor(Math.random() * 30) + 10,
                    approved: Math.floor(Math.random() * 25) + 8,
                    rejected: Math.floor(Math.random() * 5) + 1,
                    avgTime: `${Math.floor(Math.random() * 3) + 1}m ${Math.floor(Math.random() * 60)}s`
                };
            }
        },
        
        rotateTips() {
            const randomIndex = Math.floor(Math.random() * this.tips.length);
            this.currentTip = this.tips[randomIndex];
        },
        
        getUrgentStatusColor() {
            if (this.urgentCount === 0) return 'text-emerald-600 dark:text-emerald-400';
            if (this.urgentCount <= 5) return 'text-yellow-600 dark:text-yellow-400';
            return 'text-red-600 dark:text-red-400';
        },
        
        getUrgentStatus() {
            if (this.urgentCount === 0) return 'Tudo em dia!';
            if (this.urgentCount <= 5) return 'Poucos restantes';
            return 'Atenção necessária';
        },
        
        getTimeRemainingColor() {
            if (this.midDayPassed) return 'text-red-600 dark:text-red-400';
            
            const timeStr = this.remainingTimeFormatted;
            const parts = timeStr.split(':');
            const hours = parseInt(parts[0]);
            const minutes = parseInt(parts[1]);
            
            if (hours >= 2) return 'text-emerald-600 dark:text-emerald-400';
            if (hours >= 1 || minutes >= 30) return 'text-yellow-600 dark:text-yellow-400';
            return 'text-red-600 dark:text-red-400';
        },
        
        getTimeRemainingStatus() {
            if (this.midDayPassed) return 'Prazo vencido';
            
            const timeStr = this.remainingTimeFormatted;
            const parts = timeStr.split(':');
            const hours = parseInt(parts[0]);
            const minutes = parseInt(parts[1]);
            
            if (hours >= 2) return 'Tempo suficiente';
            if (hours >= 1 || minutes >= 30) return 'Acelerar ritmo';
            return 'Urgente!';
        },
        
        getProgressBarColor() {
            if (this.urgentCount === 0) return 'bg-emerald-500';
            if (this.urgentCount <= 5) return 'bg-yellow-500';
            return 'bg-red-500';
        },
        
        getProgressPercentage() {
            if (this.urgentCount === 0) return 100;
            
            // Simula um valor inicial baseado no total estimado
            const estimatedTotal = Math.max(this.urgentCount + this.stats.today.processed, 20);
            return Math.round((this.stats.today.processed / estimatedTotal) * 100);
        },
        
        getProgressMessage() {
            if (this.urgentCount === 0) {
                return "Meta atingida! Todos os reviews urgentes foram processados.";
            }
            
            if (this.midDayPassed) {
                return `${this.urgentCount} reviews ainda pendentes após o prazo de 12h.`;
            }
            
            if (this.urgentCount <= 5) {
                return `Quase terminando! Apenas ${this.urgentCount} reviews restantes.`;
            }
            
            return `${this.urgentCount} reviews precisam ser processados até 12h.`;
        }
    },
    
    computed: {
        // Calcula precisão baseada em aprovados vs rejeitados
        calculatedAccuracy() {
            const total = this.stats.today.approved + this.stats.today.rejected;
            if (total === 0) return 100;
            return Math.round((this.stats.today.approved / total) * 100);
        }
    }
};
</script> 